export default "__VITE_ASSET__CuGw9Yrr__"